// removed by extract-text-webpack-plugin
module.exports = {"centerItems":"_3L_uNNuGMgKQzcyFuyDnhs","iconContact":"ZVGpxJxLpHaC60kgaPlfX","mail":"goIWzOCievq0iPqHqRwOS","address":"_2wZe5LtcWU1bSAp8XRgNzp","desktopStyle":"_10nPqcZIqtNVh90ihi4_am"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/Contact.css
// module id = 42
// module chunks = 0